import { BASE_TOOL_COMMON_PROPS } from '@/toolSelection/baseTool.constants';
import _ from 'lodash';
import { PersistenceLevel } from '@/core/flux.service';
import { ModelOutputV1, ReferencedInputItemV1, ReferencedOutputItemV1 } from '@/sdk';
import { ColumnDefinition } from '@/tableDefinitionEditor/tableDefinition.types';
import { BaseToolStore } from '@/toolSelection/baseTool.store';
import { OutputTypeEnum } from 'sdk/model/InputFeatureV1';
import { TREND_TOOLS } from '@/toolSelection/investigate.constants';

export interface ModelInput extends ReferencedInputItemV1 {
  id?: string;
  isCollapsed?: boolean;
  originalName?: string;
  columnDefinition?: ColumnDefinition;
  outputType?: OutputTypeEnum;
  inputType?: string;
  parent?: string;
  inputItem?: string;
}

export interface ModelOutput extends ReferencedOutputItemV1 {
  id?: string;
}

export type ModelItem = {
  name: string;
  description: string;
  id?: string;
  derivedFeatures: ColumnDefinition[] | ModelOutput[];
  inputFeatures: ModelInput[];
};

export type ModelPayload = Partial<
  Pick<ModelItem, 'name' | 'description' | 'id' | 'inputFeatures' | 'derivedFeatures'>
>;

export class ModelStore extends BaseToolStore {
  persistenceLevel: PersistenceLevel = 'WORKSHEET';

  type = TREND_TOOLS.MODEL_CREATE;

  initialize() {
    this.state = this.immutable(
      _.assign({}, BASE_TOOL_COMMON_PROPS, {
        id: '',
        description: '',
        inputFeatures: [],
        derivedFeatures: [],
        name: '',
        modelOutput: undefined,
      }),
    );
  }

  get id(): string {
    return this.state.get('id');
  }

  get name(): string {
    return this.state.get('name');
  }

  get description(): string {
    return this.state.get('description');
  }

  get derivedFeatures(): ModelOutput[] | ColumnDefinition[] {
    return this.state.get('derivedFeatures');
  }

  get inputFeatures(): ModelInput[] {
    return this.state.get('inputFeatures');
  }

  get modelOutput(): ModelOutputV1 {
    return this.state.get('modelOutput');
  }

  dehydrate() {
    return this.state.serialize();
  }

  rehydrate(dehydratedState: any) {
    this.state.merge(dehydratedState);
  }

  protected readonly handlers = {
    ...this.baseHandlers,
  };

  resetModel = () => {
    this.initialize();
  };

  setModel = ({ model }: { model: ModelOutputV1 | ModelPayload }) => {
    this.state.set('modelOutput', model);

    if (model.description !== undefined) {
      this.state.set('description', model.description);
    }
    if (model.name !== undefined) {
      this.state.set('name', model.name);
    }
    if (model.id !== undefined) {
      this.state.set('id', model.id);
    }
    if (model.inputFeatures !== undefined) {
      this.state.set('inputFeatures', model.inputFeatures ?? []);
    }
    if (model.derivedFeatures !== undefined) {
      this.state.set('derivedFeatures', model.derivedFeatures ?? []);
    }
  };
}
